import { render } from "./Pagination.vue?vue&type=template&id=7ed7fa14"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Shared/Pagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ed7fa14"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ed7fa14', __exports__)) {
    console.log('reload')
    api.reload('7ed7fa14', __exports__)
  }
  
  module.hot.accept("./Pagination.vue?vue&type=template&id=7ed7fa14", () => {
    console.log('re-render')
    api.rerender('7ed7fa14', render)
  })

}


export default __exports__